import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';
import { Alert, TitleText } from '../../../components';
import { useAppContext } from '../../../context/appContext';
import {
  EVENT_CATEGORY_FOR_USER_FLOW,
  PROPERTY_FOR_USER_FLOW,
} from '../../../../../shop/constants/signupLoginEventsTracking';

const StepSuccess = () => {
  const { userSetting } = useAppContext();
  const { t } = useTranslation();
  const injector = window.angular.element(document.body).injector();
  const trackerService = injector.get('trackerService');

  useEffect(() => {
    trackerService.track({
      type: trackerService.generalEventType.MemberSignUpSucceed,
      data: {
        event_category: EVENT_CATEGORY_FOR_USER_FLOW.SignUp,
        property: PROPERTY_FOR_USER_FLOW.sign_up_option,
        value: userSetting?.signup_method,
      },
    });
  }, []);

  return (
    <Box>
      <TitleText mb="32px">{t('Sign In')}</TitleText>
      <Alert status="success">{t('Sign up Success')}</Alert>
    </Box>
  );
};

export default StepSuccess;
